import React from "react";
import { FeedbackButton } from './FeedbackButton';
import { Grid, Icon } from 'semantic-ui-react';
import { Image } from 'semantic-ui-react';
import logo from "../../../images/logo/logo-full-black.png";

import { dispatch } from '@rematch/core';

import defaultImage from '../../../images/logo/logo-128.png'


import WhatsNew from '../../../images/help-icons/icon-help-whatsnew.svg'
import UserGuides from '../../../images/help-icons/icon-help-userguide.svg'
import Tutorials from '../../../images/help-icons/icon-help-tutorials.svg'
import UserForum from '../../../images/help-icons/icon-help-userforum.svg'
import Support from '../../../images/help-icons/icon-help-support.svg'
import ReportIssue from '../../../images/help-icons/icon-help-reportissue.svg'

import ManagingAccounts from '../../../images/help-icons/icon-whatsnew-accounts.svg'
import WorkspaceDashboard from '../../../images/help-icons/icon-whatsnew-workspace.svg'
import CustomizableCategories from '../../../images/help-icons/icon-whatsnew-customize.svg'
import EasyRoleMapping from '../../../images/help-icons/icon-whatsnew-mapping.svg'
import SimplifiedDependencies from '../../../images/help-icons/icon-whatsnew-dependencies.svg'

import Conductor from '../../../images/help-icons/icon-userguides-conductor.svg'
import Designer from '../../../images/help-icons/icon-userguides-designer.svg'
import Navigator from '../../../images/help-icons/icon-userguides-navigator.svg'

import AccountSetup from '../../../images/help-icons/icon-tutorials-account.svg'
import UsingWorkspaces from '../../../images/help-icons/icon-tutorials-workspace.svg'
import BuildingCommunity from '../../../images/help-icons/icon-tutorials-community.svg'
import GrowYourContentLibrary from '../../../images/help-icons/icon-tutorials-content.svg'
import DesigningYourFirstPlaybook from '../../../images/help-icons/icon-tutorials-playbook.svg'
import LaunchinganInitiative from '../../../images/help-icons/icon-tutorials-initiative.svg'
import TrackingYourProgress from '../../../images/help-icons/icon-tutorials-progress.svg'
import ManagingNotifications from '../../../images/help-icons/icon-tutorials-notifications.svg'


const styles = {
    dockContent: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    remove: {
        position: 'absolute',
        zIndex: 1,
        right: '10px',
        top: '10px',
        cursor: 'pointer'
    }
};

let version;
class HelpPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            back: false,
            oraginalContent: props.helpContent && props.helpContent[0] ? props.helpContent[0].content : [],
            details: props.helpContent && props.helpContent[0] ? props.helpContent[0].content : []
        }
    }

    componentWillMount() {
        this.setState({ details: this.props.helpContent && this.props.helpContent[0] ? this.props.helpContent[0].content : [], back: false })
    }

    componentWillUnmount() {
        this.setState({ details: this.props.helpContent && this.props.helpContent[0] ? this.props.helpContent[0].content : [], back: false })
    }


    download_file(url) {

        var a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", url);
        a.setAttribute("target", "_blank");
        a.click();

    }



    changePage(e, details) {

        // if (details.name === "User Forum") {
        //     return window.open('https://forums.aspenify.com/', '_blank')
        // } else
        if (details.name === "Support") {
            return window.open('https://www.aspenify.com/support/', '_blank')
        }

        if (details.type || details.path || this.state.back) {
            if (details.type === "video") {
                dispatch.help.setVideoDetails(details)
            } else if (details.type === "pdf") {
                this.download_file(details.path); // fix function name
            } else {

            }
        } else {
            this.setState({ details: details.data, back: true, name: details.name })
        }
    }

    closeDock() {
        this.props.handleHelpVisibleChange(false);
        this.setState({ details: this.state.oraginalContent, back: false })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.helpContent !== newProps.helpContent) {
            this.setState({ oraginalContent: newProps.helpContent[0].content })
            this.setState({ details: newProps.helpContent[0].content })
        }
    }

    render() {
        const date = new Date()
        let windowHeight = window.innerHeight;
        let subTitle =
            <React.Fragment >
                <Icon name="chevron right" />
                {this.state.name}
            </React.Fragment>
        return (
            <div  >
                <h4 className="pane_header bg-light-blue">
                    {this.state.back ? <span className="cursor-pointer" onClick={() => this.setState({ details: this.state.oraginalContent, back: false })}><Icon name="arrow left" /> Need Help! </span> : 'Need Help!'}
                    &nbsp;
                    {this.state.back ? subTitle : null}
                    <Icon name="close" className="closeIcon" onClick={() => this.closeDock()} />
                </h4>
                <div className="helpBlock" className="bg-light-blue " style={{ maxHeight: windowHeight - 137, minHeight: windowHeight - 137, overflow: "auto" }}>
                    <div className="pad_10 ">
                        {this.state.details ?
                            this.state.details && this.state.details.length > 0 && this.state.details.map((item, i) => {
                                return item.name === "Report Issue" ?
                                    <FeedbackButton item={item} key={i} />
                                    :
                                    <div
                                        key={i}
                                        className=" pad_10 mar_tb_5 bg-white bdr-rds-4 float-left w_100 hoverEffect "
                                        onClick={(e) => this.changePage(e, item)}>
                                        <div className="float-left" style={{ width: "32px" }}>
                                            <Image src={
                                                item.icon === "WhatsNew" ? WhatsNew :
                                                    item.icon === "UserGuides" ? UserGuides :
                                                        item.icon === "Tutorials" ? Tutorials :
                                                            item.icon === "UserForum" ? UserForum :
                                                                item.icon === "Support" ? Support :
                                                                    item.icon === "ReportIssue" ? ReportIssue :
                                                                        item.icon === "ManagingAccounts" ? ManagingAccounts :
                                                                            item.icon === "WorkspaceDashboard" ? WorkspaceDashboard :
                                                                                item.icon === "CustomizableCategories" ? CustomizableCategories :
                                                                                    item.icon === "EasyRoleMapping" ? EasyRoleMapping :
                                                                                        item.icon === "SimplifiedDependencies" ? SimplifiedDependencies :
                                                                                            item.icon === "Conductor" ? Conductor :
                                                                                                item.icon === "Designer" ? Designer :
                                                                                                    item.icon === "Navigator" ? Navigator :
                                                                                                        item.icon === "AccountSetup" ? AccountSetup :
                                                                                                            item.icon === "UsingWorkspaces" ? UsingWorkspaces :
                                                                                                                item.icon === "BuildingCommunity" ? BuildingCommunity :
                                                                                                                    item.icon === "GrowYourContentLibrary" ? GrowYourContentLibrary :
                                                                                                                        item.icon === "DesigningYourFirstPlaybook" ? DesigningYourFirstPlaybook :
                                                                                                                            item.icon === "LaunchinganInitiative" ? LaunchinganInitiative :
                                                                                                                                item.icon === "TrackingYourProgress" ? TrackingYourProgress :
                                                                                                                                    item.icon === "ManagingNotifications" ? ManagingNotifications : defaultImage} />
                                        </div>
                                        <div className="float-left" style={{ width: "calc(100% - 32px)", padding: "0 0 0 20px" }}>
                                            <h4 className="mar_0">{item.name}</h4>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                            }) :
                            <div className="pad_10 mar_tb_5 bg-white bdr-rds-4 float-left w_100 "                            >
                                <div className="float-left" style={{ width: "100%" }}>
                                    <h4 className="mar_0">coming soon...</h4>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <Grid className="helpVersion bg-light-blue" >
                    <Grid.Row className="pad_5 bg-white" >
                        <Grid.Column width={16} >
                            If you cannot find what you are looking for don’t hesitate to reach out to us at <a href="mailto:support@aspenify.com" target="_blank">support@aspenify.com</a>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className="pad_5" >
                        <Grid.Column width={6} >
                            <Image src={logo} />
                        </Grid.Column>
                        <Grid.Column width={10} className="text-right">
                            Version {this.props.version}
                            <br />
                            Copyright &#169; {date.getFullYear()} Aspenify
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
export default HelpPane;